import {
  HOME_PAGE_FEATURE_ANNOUNCEMENT,
  HOME_PAGE_FEATURE_CALENDAR,
  HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
  HOME_PAGE_FEATURE_MESSAGING,
  HOME_PAGE_FEATURE_PROGRESS_REPORT,
  HOME_PAGE_FEATURE_ATTENDANCE,
  HOME_PAGE_FEATURE_CLASSROOM_TODO,
  HOME_PAGE_FEATURE_GOALS,
  HOME_PAGE_FEATURE_TIMETABLE,
  HOME_PAGE_FEATURE_TIMETABLE_MANAGER,
  HOME_PAGE_FEATURE_COURSES,
  HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_HOMEROOM,
  HOME_PAGE_FEATURE_DP_SUBJECT_CENTER,
  HOME_PAGE_FEATURE_TODDLE_ANALYTICS,
  HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  HOME_PAGE_FEATURE_SNP,
  HOME_PAGE_FEATURE_LEARNER_PORTFOLIO,
  HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
  HOME_PAGE_FEATURE_CURRICULUM_MAPS,
  HOME_PAGE_PORTFOLIO_REVIEW,
  HOME_PAGE_FEATURE_PLANNING_INSIGHTS,
  HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS,
  HOME_PAGE_FEATURE_STUDENT_PLANS,
  HOME_PAGE_FEATURE_GRADEBOOK,
  HOME_PAGE_FEATURE_MCGRAW_HILL_LTI,
  HOME_PAGE_POWER_BI_CARD,
} from "Courses/components/TeacherCourses/Constants";

export const PROGRAMME_HOME_PAGE_LAYOUT = "ProgrammeHomepageLayout";
export const QUICK_LINK_DESCRIPTION_MAX_WORD_LIMIT = 30;

export const LINK_MODAL_MODE_EDIT = "EDIT";
export const LINK_MODAL_MODE_ADD = "ADD";
export const LINK_MODAL_MODE_CONFIGURE = "CONFIGURE";

export const WIDGET_TYPES = {
  QUICK_LINKS: "QUICK_LINKS",
  BANNER: "BANNER",
  RICH_TEXT_EDITOR: "RICH_TEXT_EDITOR",
};

export const MAX_SCREEN_WIDTH_FOR_BUTTON_VISIBILITY = 1200;

export const RESIZE_HANDLES = ["s", "e", "w", "n", "se", "sw", "nw", "ne"];

export const EAST_HANDLE = "e";
export const WEST_HANDLE = "w";
export const NORTH_HANDLE = "n";
export const SOUTH_HANDLE = "s";
export const NORTH_EAST_HANDLE = "ne";
export const SOUTH_WEST_HANDLE = "sw";
export const NORTH_WEST_HANDLE = "nw";
export const SOUTH_EAST_HANDLE = "se";

export const MINIMUM_WIDTH_FOR_RESIZE_HANDLE = "24px";
export const MINIMUM_HEIGHT_FOR_RESIZE_HANDLE = "24px";

// Maps FE keys to BE keys
export const HOMEPAGE_FEATURE_KEY_MAP = {
  [HOME_PAGE_FEATURE_ANNOUNCEMENT]: "announcements",
  [HOME_PAGE_FEATURE_ATTENDANCE]: "attendanceDashboard",
  [HOME_PAGE_FEATURE_CLASSROOM_TODO]: "assignmentsManager",
  [HOME_PAGE_FEATURE_CALENDAR]: "calendar",
  [HOME_PAGE_FEATURE_FAMILY_COMMUNICATION]: "familyMessaging",
  [HOME_PAGE_FEATURE_MESSAGING]: "messaging",
  [HOME_PAGE_FEATURE_PROGRESS_REPORT]: "progressReports",
  [HOME_PAGE_FEATURE_SNP]: "authorizationAndEvaluation",
  [HOME_PAGE_FEATURE_LEARNER_PORTFOLIO]: "learnerPortfolio",
  [HOME_PAGE_FEATURE_EDUCATOR_CENTER]: "schoolPoliciesAndResources",
  [HOME_PAGE_FEATURE_GOALS]: "studentGoals",
  [HOME_PAGE_FEATURE_HOMEROOM]: "homeroom",
  [HOME_PAGE_FEATURE_DP_SUBJECT_CENTER]: "subjectCenter",
  [HOME_PAGE_FEATURE_TODDLE_ANALYTICS]: "insights",
  [HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT]: "behaviourManagement",
  [HOME_PAGE_FEATURE_SCHOOL_LIBRARY]: "schoolLibrary",
  [HOME_PAGE_FEATURE_CURRICULUM_MAPS]: "curriculumMaps",
  [HOME_PAGE_PORTFOLIO_REVIEW]: "portfolioReview",
  [HOME_PAGE_FEATURE_TIMETABLE]: "timetable",
  [HOME_PAGE_FEATURE_TIMETABLE_MANAGER]: "timetableManager",
  [HOME_PAGE_FEATURE_PLANNING_INSIGHTS]: "planningInsights",
  [HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS]: "curriculumInsights",
  [HOME_PAGE_FEATURE_STUDENT_PLANS]: "studentPlans",
  [HOME_PAGE_FEATURE_GRADEBOOK]: "gradebook",
  [HOME_PAGE_FEATURE_COURSES]: "courses",
  [HOME_PAGE_FEATURE_MCGRAW_HILL_LTI]: "homepageBasedLti",
  [HOME_PAGE_POWER_BI_CARD]: "powerBiCards",
};

export const HOMEPAGE_WIDGETS_BE_KEYS = {
  assignmentsManager: "assignmentsManager",
  quickLinkWidget: "quickLinkWidget",
  userWidgetPreference: "userWidgetPreference",
  toddleLibraryEnabled: "toddleLibraryEnabled",
  libraryBannerFeed: "libraryBannerFeed",
  timetableWidget: "timetableWidget",
  timetablePlannerWidget: "timetablePlannerWidget",
};
